import { Injectable } from '@angular/core';

import { GlobalService } from '../../../services/global.service';
import * as firebase from 'firebase/app';

@Injectable()
export class ChatService {

  display_myprofile: boolean;
  display_other_profile: boolean;
  display_edit_profile: boolean ;
  display_add_files: boolean ;
  display_addFriend: boolean ;

  constructor(
    public _globalService: GlobalService,

  ) {
    // console.log('chat service');

  }

  sendMessage(message, fileType, thumbnail?): any {
    // console.log('send msg ', message, fileType, thumbnail);
    const data = {
      date: firebase.database.ServerValue.TIMESTAMP,
      payload: fileType === 0 ? message : '',
      fileSrc: fileType !== 0 ? message : '',
      fileName: fileType !== 0 ? this.getFileName(message) : '',
      pictureThumbnail: thumbnail ? thumbnail : '',
      type: fileType,
      user_firebase_id: this._globalService._fireAuth.auth.currentUser.uid,
      JSON: '{"text":"' + message + '"}'
    };

    const message_path = this._globalService.root_path + '/' +
      this._globalService.domain + '/messages/' + this._globalService.selected_thread.thread_id;

    return this._globalService._fireDB.database.ref(message_path).push(data);

  }

  getFileName(value) {
    if (value) {
      const str_sub1 = value.substr(0, value.lastIndexOf('?'));
      const str_sub2 = str_sub1.substr(str_sub1.lastIndexOf('_') + 1 );
      const str_sub3 = str_sub2.replace(/%20/g, ' ');
      if (str_sub3) {
        return str_sub3;
      }
    }
  }

  onUnseenCount() {
    //  unseen count
    const unseen_count_path: any = this._globalService.root_path + '/' +
      this._globalService.domain + '/users/' + this._globalService.selected_thread.user_id +
      '/threads/' + this._globalService.selected_thread.thread_id + '/unseenCount';

    let unseen_count: number = 1;
    this._globalService._fireDB.object(unseen_count_path).valueChanges().first()
      .subscribe((unseenCount: any) => {
        // console.log('counttttt ', unseenCount, unseen_count_path);

        if (unseenCount) {
          unseen_count = Number(unseenCount) + 1;
        }

        // update unseen count
        this._globalService.updateUnseenCount(this._globalService.selected_thread.thread_id,
          this._globalService.selected_thread.user_id, unseen_count);
        // end update unseen count

      });
    // end
  }

  onLastMessageAdded() {
    // last message added in thread 
    const master_thread_path = this._globalService.root_path + '/'
      + this._globalService.domain + '/threads/' +
      this._globalService.selected_thread.thread_id + '/details/last_message_added';

    const datasave = {};
    datasave[master_thread_path] = firebase.database.ServerValue.TIMESTAMP;
    this._globalService.firebaseUpdate(datasave);
    // end
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/services/chat.service.ts